var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWheat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi_10442196",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.78 101.33c-4 9.67-11.78 15.54-17.48 13.19s-7-12.06-3-21.7 16.15-21.74 16.15-21.74 10.63 15.08 4.33 30.25z",
    fill: "#ffca28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m41.3 89.15c-9.49 2.92-15.79 9.79-14.08 15.36s10.79 7.72 20.28 4.8 22.06-13.31 22.06-13.31-13.32-11.44-28.26-6.85z",
    fill: "#ffc943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m48.11 75.4c-3.72 9-11 14.46-16.27 12.28s-6.52-11.23-2.84-20.2 15-20.24 15-20.24 10 14.04 4.11 28.16z",
    fill: "#ffc943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m65.06 63.18c-8.67 2.66-14.42 8.94-12.86 14s9.85 7.05 18.52 4.39 20.15-12.14 20.15-12.14-12.17-10.43-25.81-6.25z",
    fill: "#ffcc5a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m73.32 50c-3.11 7.48-9.19 12.07-13.58 10.25s-5.43-9.37-2.32-16.85 12.58-16.86 12.58-16.86 8.22 11.72 3.32 23.46z",
    fill: "#ffcc5a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m88 40.42c-7.4 2.26-12.3 7.58-11 11.93s8.38 6 15.75 3.73 17.14-10.35 17.14-10.35-10.32-8.88-21.89-5.31z",
    fill: "#ffcf6e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m96.71 27.56c-2.89 7-8.55 11.23-12.64 9.54s-5.07-8.73-2.16-15.69 11.67-15.73 11.67-15.73 7.69 10.91 3.13 21.88z",
    fill: "#ffcf6e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m107.95 21.37c-6.73 2.07-11.2 6.95-10 10.9s7.65 5.48 14.39 3.41 15.66-9.45 15.66-9.45-9.45-8.12-20.05-4.86z",
    fill: "#ffd488"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m23.82 112.73c-6.73 2.07-11.2 6.95-10 10.9s7.65 5.48 14.39 3.41 15.65-9.45 15.65-9.45-9.44-8.12-20.04-4.86z",
    fill: "#ffca28"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m113.29 14.77c-3.37 4.1-7.81 6-9.91 4.3s-1.06-6.45 2.31-10.55 10.76-8.52 10.76-8.52 2.16 8.32-3.16 14.77z",
    fill: "#ffd488"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheat);
export default __webpack_public_path__ + "static/media/wheat.35d6cb67c78c83e713ae1277373f9421.svg";
export { ForwardRef as ReactComponent };